import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Modal, Tabs, message } from 'antd';
import { Login } from './Login';
import { Register } from './Register';
import { ForgetPassoword } from './ForgetPassword';
import { logIn, register, selectLoggingIn, selectError, selectSuccess, resetPassoword, resetError } from './authSlice';
import styles from './Auth.module.scss';

export const Auth = ({ isVisible, onCancel, isLoggedIn }) => {
  const query = new URLSearchParams(useLocation().search);
  const queryName = query.get('auth');

  const [isActive, setActive] = useState(false);
  const [activeTab, setActiveTab] = useState('signin');

  useEffect(() => {
    console.log('queryName', queryName)
    if (queryName === 'signin' || queryName === 'register' || queryName === 'forgetPassoword' ) {
      setActiveTab(queryName);
      setActive(true);
    }
  }, [queryName]);

  const dispatch = useDispatch();
  const loggingIn = useSelector(selectLoggingIn);
  const error = useSelector(selectError);
  const success = useSelector(selectSuccess);

  const onLogin = ({ email, password }) => {
    dispatch(resetError());
    dispatch(logIn(email, password));
  }

  const onRegister = ({ email, password, first_name, last_name }) => {
    dispatch(resetError());
    dispatch(register(email, password, first_name, last_name));
  }

  const onResetPassword = ({ email}) => {
    dispatch(resetError());
    dispatch(resetPassoword(email));
  }

  useEffect(() => {
    if(error) {
      dispatch(resetError());
      // onCancel();
    }
  }, [activeTab])

  useEffect(() => {
    if(error) {
      message.error(error);
      // onCancel();
    }
  }, [error])

  useEffect(() => {
    if(success) {
      message.success(success);
      onCancel();
    }
  }, [success])

  if (isLoggedIn) return null;

  return (
    <Modal
      open={isVisible || isActive}
      onCancel={() => {
        if (isActive) setActive(false);
        onCancel();
      }}
      footer={null}
      width={450}>
      <Tabs defaultActiveKey="login" activeKey={activeTab} renderTabBar={() => null}>
        <Tabs.TabPane tab="Login" key="signin">
          <Login
            onSubmit={onLogin}
            disabled={loggingIn}
            toggleActiveTab={() => setActiveTab('register')}
            toggleActiveTab2={() => setActiveTab('forgetPassoword')}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Register" key="register">
          <Register
            onSubmit={onRegister}
            disabled={loggingIn}
            toggleActiveTab={() => setActiveTab('signin')}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Forget Passoword" key="forgetPassoword">
          <ForgetPassoword
            onSubmit={onResetPassword}
            disabled={loggingIn}
            toggleActiveTab={() => setActiveTab('signin')}
          />
        </Tabs.TabPane>
      </Tabs>
      <div className={ styles.error }>{error}</div>
    </Modal>
  );
}
